import React from "react";
import { RouteObject } from "../../interfaces/navigation";

const EntryPoint = React.lazy(() => import("../../containers/LinzeCheck/EntrypointContainer"));

export const linzeCheckRoutes: RouteObject[] = [
    {
        path: "/revision-tecnica-auto",
        component: <EntryPoint />,
        title: "Informe Técnico"
    }
];
